import { render, staticRenderFns } from "./TargetScoreInput.vue?vue&type=template&id=00146db4&"
import script from "./TargetScoreInput.vue?vue&type=script&lang=js&"
export * from "./TargetScoreInput.vue?vue&type=script&lang=js&"
import style0 from "./TargetScoreInput.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports